enum MessagesTypes {
    NEW_MESSAGE = 'NEW_MESSAGE',
    SEND_MESSAGE = 'SEND_MESSAGE',
    CLEAR_MESSAGES = 'CLEAR_MESSAGES',
    SET_MESSAGE_STATUS = 'SET_MESSAGE_STATUS',
    SEND_FILE = 'SEND_FILE',
    GET_TRANSCRIPT = 'GET_TRANSCRIPT',
    SET_DELIVERED_TIMESTAMP = 'SET_DELIVERED_TIMESTAMP',
    SET_READ_TIMESTAMP = 'SET_READ_TIMESTAMP',
    MARK_CHAT_MESSAGE_RECEIPTS_AS_READ = 'MARK_CHAT_MESSAGE_RECEIPTS_AS_READ'
}

export default MessagesTypes;